import { Routes, Route } from "react-router-dom";
import PrivateAuth from "../../authorization/PrivateAuth";
import ItemList from "../../../pages/Master/Item/Main/Item";
import CreateItem from "../../../pages/Master/Item/Create-Item/CreateItem";
import EditItem from "../../../pages/Master/Item/Edit-Item/EditItem";
import ViewItem from "../../../pages/Master/Item/View-Item/Viewitem";


import ItemGroupList from "../../../pages/Master/ItemGroup/Main/Item-group";
import CreateItemGroup from "../../../pages/Master/ItemGroup/Create-Item-Group/CreateItemGroup";
import EditItemGroup from "../../../pages/Master/ItemGroup/Edit-Item-Group/EditItemGroup";
import ViewItemGroup from "../../../pages/Master/ItemGroup/View-Item-Group/Viewitemgroup";

import BrandList from "../../../pages/Master/Brand/Main/Brand";
import CreateBrand from "../../../pages/Master/Brand/Create-Brand/CreateBrand";
import EditBrand from "../../../pages/Master/Brand/Edit-Brand/EditBrand";
import ViewBrand from "../../../pages/Master/Brand/View-Brand/Viewbrand";
import CompanyList from "../../../pages/Master/Company/CompanyList/CompanyList";

import TaxList from "../../../pages/Master/Tax/Main-List-Page/Tax";
import CreateTax from "../../../pages/Master/Tax/Create-Tax/Createtax";
import ViewTax from "../../../pages/Master/Tax/View-tax/Viewtax";
import EditTax from "../../../pages/Master/Tax/Edit-Tax/Edittax";

import PurchasTaxList from "../../../pages/Master/PurchaseTax/Main-List-Page/Tax"
import CreatePurchaseTax from "../../../pages/Master/PurchaseTax/Create-Tax/Createtax"
import EditPurchaseTax from "../../../pages/Master/PurchaseTax/Edit-Tax/Edittax"
import ViewPurchaseTax from "../../../pages/Master/PurchaseTax/View-Tax/Viewtax"

import SupplierList from "../../../pages/Master/Supplier/Main-List-page/Supplier"
import CreateSupplier from "../../../pages/Master/Supplier/Create-Supplier/CreateSupplier"
import Viewsupplier from "../../../pages/Master/Supplier/View-supplier/Viewsupplier";
import Edisupplier from "../../../pages/Master/Supplier/Edit-supplier/Editsupplier";

import CustomerList from "../../../pages/Master/Customer/Main-List-Page/Customer"
import CreateCustomer from "../../../pages/Master/Customer/Create-customer/CreateCutomer"
import ViewCustomer from '../../../pages/Master/Customer/View-customer/ViewCusotmer'
import EditCustomer from "../../../pages/Master/Customer/Edit-customer/EditCustomer";

import AddressList from "../../../pages/Master/Address/Main-List/Address"
import CreateAddress from "../../../pages/Master/Address/Create-Address/CreaterAddress"
import ViewAddress from "../../../pages/Master/Address/View-Address/ViewAddress";
import EditAddress from "../../../pages/Master/Address/Edit-Address/EditAddress";
import WarehouseMaster from "../../../pages/Master/WarehouseMaster/List/WarehouseMaster";

import CreateWarehouseMaster from "../../../pages/Master/WarehouseMaster/Create/CreateWarehouseMaster";
import ViewWarehousemaster from "../../../pages/Master/WarehouseMaster/view/ViewWarehousemaster";
import UpdateWarehouseMaster from "../../../pages/Master/WarehouseMaster/update/UpdateWarehouseMaster";
import BinMaster from "../../../pages/Master/BinMaster/List/BinMaster";
import CreateBinMaster from "../../../pages/Master/BinMaster/Create/CreateBinMaster";
import ViewBinmaster from "../../../pages/Master/BinMaster/view/ViewBinmaster";
import UpdateBinMaster from "../../../pages/Master/BinMaster/update/UpdateBinMaster";

import CreateCompany from "../../../pages/Master/Company/Create-Company/CreateCompany";
import ViewCompany from "../../../pages/Master/Company/View-Company/ViewCompany";
import EditCompany from "../../../pages/Master/Company/Edit-Company/EditCompany";

import Contact from "../../../pages/Master/contact/Main-List-Page/Contact";
import CreateContact from "../../../pages/Master/contact/Create-contact/CreateContact";

import SerialnoList from "../../../pages/Master/SerialNo/Main/SerialList";
import CreateSerialno from "../../../pages/Master/SerialNo/CreateSerialNo/CreateSerialList";
import ViewSerialno from "../../../pages/Master/SerialNo/View-Serial-No/ViewSerialList";
import EditSerialno from "../../../pages/Master/SerialNo/Edit-Serial-No/EditSerialList";

import UOMList from "../../../pages/Master/UOM/Main/UOM";
import CreateUOM from "../../../pages/Master/UOM/Create-UOM/CreateUOM";
import EditUOM from "../../../pages/Master/UOM/Edit-UOM/EditUOM";

import ViewUOM from "../../../pages/Master/UOM/View-UOM/Viewuom";
import ItemAttributeList from "../../../pages/Master/ItemAttribute/Main/ItemAttribute";
import CreateItemAttribute from "../../../pages/Master/ItemAttribute/Create-ItemAttribute/CreateItemAttribute";
import EditItemAttribute from "../../../pages/Master/ItemAttribute/Edit-ItemAttribute/EditItemAttribute";
import ViewItemAttribute from "../../../pages/Master/ItemAttribute/View-ItemAttribute/Viewitemattribute";

import ItemPriceList from "../../../pages/Master/ItemPrice/Main/ItemPrice";
import CreateItemPrice from "../../../pages/Master/ItemPrice/Create-ItemPrice/CreateItemPrice";
import EditItemPrice from "../../../pages/Master/ItemPrice/Edit-ItemPrice/EditItemPrice";
import ViewItemPrice from "../../../pages/Master/ItemPrice/View-ItemPrice/ViewItemPrice";

import Supplier1List from "../../../pages/Master/Supplier1/Main/Supplier"
import CreateSupplier1 from "../../../pages/Master/Supplier1/Create-Supplier/CreateSupplier"
import ViewSupplier1 from "../../../pages/Master/Supplier1/View-Supplier/ViewSupplier";
import EditSupplier1 from "../../../pages/Master/Supplier1/Edit-Supplier/EditSupplier";


import PaymentTermList from "../../../pages/Master/PaymentTerm/Main/PaymentTerm"
import CreatePaymentTerm from "../../../pages/Master/PaymentTerm/Create-PaymentTerm/CreatePaymentTerm"
import ViewPaymentTerm from "../../../pages/Master/PaymentTerm/View-PaymentTerm/ViewPaymentTerm";
import EditPaymentTerm from "../../../pages/Master/PaymentTerm/Edit-PaymentTerm/EditPaymentTerm";


import PaymentTermTemplateList from "../../../pages/Master/PaymentTermTemplate/Main/PaymentTermTemplate"
import CreatePaymentTermTemplate from "../../../pages/Master/PaymentTermTemplate/Create-PaymentTermTemplate/CreatePaymentTermTemplate"
import ViewPaymentTermTemplate from "../../../pages/Master/PaymentTermTemplate/View-PaymentTermTemplate/ViewPaymentTermTemplate";
import EditPaymentTermTemplate from "../../../pages/Master/PaymentTermTemplate/Edit-PaymentTermTemplate/EditPaymentTermTemplate";

import CreateItemtax from "../../../pages/Master/Item-tax-template/Create-ItemTax/CreateitemTax"
import ItemTaxList from "../../../pages/Master/Item-tax-template/Main/Itemtax"

import ViewContact from "../../../pages/Master/contact/view-contact/ViewContact";


import ViewItemTax from "../../../pages/Master/Item-tax-template/View-item Tax/ViewItemTax"
import EditItemTax from "../../../pages/Master/Item-tax-template/Edit-Item-Tax/EditItemtax"

import GStHsnList from "../../../pages/Master/Gst-Hsn-Code/Main-content/Gsthsn"
import CreateGstHsn from "../../../pages/Master/Gst-Hsn-Code/Create-Gst-Hsn/createGstHsn";
import Editgsthsn from "../../../pages/Master/Gst-Hsn-Code/Edit-Gst-Hsn/Editgsthsn";
import Viewgsthsn from "../../../pages/Master/Gst-Hsn-Code/View-gst-Hsn/Viewgsthsn";
import DuplicateItem from "../../../pages/Master/Item/Duplicate-Item/DuplicateItem";
import ZoneMaster from "../../../pages/Master/ZoneMaster/List/ZoneMaster";
import CreateZoneMaster from "../../../pages/Master/ZoneMaster/Create/CreateZoneMaster";
import UpdateZoneMaster from "../../../pages/Master/ZoneMaster/update/UpdateWarehouseMaster";
import ViewZonemaster from "../../../pages/Master/ZoneMaster/view/ViewWarehousemaster";

function MasterRoute() {
  return (
    <Routes>
      <Route element={<PrivateAuth />}>


        <Route path="serialno/serialno-list" element={<SerialnoList />} />
        <Route path="serialno/serialno-create" element={<CreateSerialno />} />
        <Route path="serialno/serialno-view" element={<ViewSerialno />} />
        <Route path="serialno/serialno-edit" element={<EditSerialno />} />

        {/* Item Route */}
        <Route path="item/item-list" element={<ItemList />} />
        <Route path="item/create-item" element={<CreateItem />} />
        <Route path="item/edit-item" element={<EditItem />} />
        <Route path="item/view-item" element={<ViewItem />} />
        <Route path='item/duplicate-item' element={<DuplicateItem/>} />

        {/* Item group route */}
        <Route path="itemgroup/item-group-list" element={<ItemGroupList />} />
        <Route path="itemgroup/create-item-group" element={<CreateItemGroup />} />
        <Route path="itemgroup/edit-item-group" element={<EditItemGroup />} />
        <Route path="itemgroup/view-item-group" element={<ViewItemGroup />} />

        <Route path="brand/brand-list" element={<BrandList />} />
        <Route path="brand/create-brand" element={<CreateBrand />} />
        <Route path="brand/edit-brand/" element={<EditBrand />} />
        <Route path="brand/view-brand/" element={<ViewBrand />} />

        <Route path="tax/tax-list" element={<TaxList />} />
        <Route path="tax/create-tax" element={<CreateTax />} />
        <Route path="tax/view-tax" element={<ViewTax />} />
        <Route path="tax/edit-tax" element={<EditTax />} />

        <Route path="tax/purchase-tax-list" element={<PurchasTaxList />} />
        <Route path="tax/purchase-create-tax" element={<CreatePurchaseTax />} />
        <Route path="tax/purchase-view-tax" element={<ViewPurchaseTax />} />
        <Route path="tax/purchase-edit-tax" element={<EditPurchaseTax />} />

        {/* Supplier Routes */}
        <Route path="suppliergroup/supplier-list" element={<SupplierList />} />
        <Route path="suppliergroup/create-supplier" element={<CreateSupplier />} />
        <Route path="suppliergroup/view-supplier" element={<Viewsupplier />} />
        <Route path="suppliergroup/edit-supplier" element={<Edisupplier />} />

        {/* Customer Routes */}
        <Route path="customer/customer-list" element={<CustomerList />} />
        <Route path="customer/create-customer" element={<CreateCustomer />} />
        <Route path="customer/view-customer" element={<ViewCustomer />} />
        <Route path="customer/edit-customer" element={<EditCustomer />} />

        {/* Adress Routes */}
        <Route path="address/address-list" element={<AddressList />} />
        <Route path="address/create-address" element={<CreateAddress />} />
        <Route path="address/view-address" element={<ViewAddress />} />
        <Route path="address/edit-address" element={<EditAddress />} />

        {/* Item Routes */}
        <Route path="itemtax/create-item-tax" element={<CreateItemtax />} />
        <Route path="itemtax/item-tax-list" element={<ItemTaxList />} />
        <Route path="itemtax/item-tax-view" element={<ViewItemTax />} />
        <Route path="itemtax/item-tax-edit" element={<EditItemTax />} />

        {/* HSN Routes */}
        <Route path="gsthsncode/gst-hsn-list" element={<GStHsnList />} />
        <Route path="gsthsncode/gst-hsn-create" element={<CreateGstHsn />} />
        <Route path="gsthsncode/gst-hsn-edit" element={<Editgsthsn />} />
        <Route path="gsthsncode/gst-hsn-view" element={<Viewgsthsn />} />



        {/* section for warehouse master */}

        <Route path="/warehouse-list" element={<WarehouseMaster />} />
        <Route path="/create-warehouse" element={<CreateWarehouseMaster />} />
        <Route path="/warehouse-view" element={<ViewWarehousemaster />} />
        <Route path="/warehouse-edit" element={<UpdateWarehouseMaster />} />

        <Route path="/zone-list" element={<ZoneMaster />} />
        <Route path="/create-zone" element={<CreateZoneMaster />} />
        <Route path="/zone-edit" element={<UpdateZoneMaster />} />
        <Route path="/zone-view" element={<ViewZonemaster />} />


        <Route path="/bin-list" element={<BinMaster />} />
        <Route path="/create-bin" element={<CreateBinMaster />} />
        <Route path="/bin-view" element={<ViewBinmaster />} />
        <Route path="/bin-edit" element={<UpdateBinMaster />} />

        {/* ware house master section end */}

        {/* contact master */}
        <Route path="/contact-list" element={<Contact />} />
        <Route path="/create-contact" element={<CreateContact />} />
        <Route path="/view-contact" element={<ViewContact />} />



        {/* contact master */}
        <Route path="company/company-list" element={<CompanyList />} />
        <Route path="company/create-Company" element={<CreateCompany />} />
        <Route path="company/view-Company" element={<ViewCompany />} />
        <Route path="company/edit-Company" element={<EditCompany />} />

        {/* UOM Routes */}
        <Route path="uom/uom-list" element={<UOMList />} />
        <Route path="uom/create-uom" element={<CreateUOM />} />
        <Route path="uom/edit-uom" element={<EditUOM />} />
        <Route path="uom/view-uom" element={<ViewUOM />} />

        {/* Item Attribute Routes */}
        <Route path="item-attribute/item-attribute-list" element={<ItemAttributeList />} />
        <Route path="item-attribute/create-item-attribute" element={<CreateItemAttribute />} />
        <Route path="item-attribute/edit-item-attribute" element={<EditItemAttribute />} />
        <Route path="item-attribute/view-item-attribute" element={<ViewItemAttribute />} />

        {/* Item Price Routes */}
        <Route path="item-price/item-price-list" element={<ItemPriceList />} />
        <Route path="item-price/create-item-price" element={<CreateItemPrice />} />
        <Route path="item-price/edit-item-price" element={<EditItemPrice />} />
        <Route path="item-price/view-item-price" element={<ViewItemPrice />} />

        {/* Supplier Routes */}
        <Route path="supplier/supplier-list" element={<Supplier1List />} />
        <Route path="supplier/create-supplier" element={<CreateSupplier1 />} />
        <Route path="supplier/view-supplier" element={<ViewSupplier1 />} />
        <Route path="supplier/edit-supplier" element={<EditSupplier1 />} />

        {/* Payment Routes */}
        <Route path="payment-term/payment-term-list" element={<PaymentTermList />} />
        <Route path="payment-term/create-payment-term" element={<CreatePaymentTerm />} />
        <Route path="payment-term/view-payment-term" element={<ViewPaymentTerm />} />
        <Route path="payment-term/edit-payment-term" element={<EditPaymentTerm />} />

        {/* Payment Term Routes */}
        <Route path="payment-term-template/payment-term-template-list" element={<PaymentTermTemplateList />} />
        <Route path="payment-term-template/create-payment-term-template" element={<CreatePaymentTermTemplate />} />
        <Route path="payment-term-template/view-payment-term-template" element={<ViewPaymentTermTemplate />} />
        <Route path="payment-term-template/edit-payment-term-template" element={<EditPaymentTermTemplate />} />

      </Route>
    </Routes>
  );
}

export default MasterRoute;
